// src/firebase.js
import { initializeApp } from 'firebase/app'
import { 
    getAuth, 
    GoogleAuthProvider, 
    FacebookAuthProvider,
    setPersistence,
    indexedDBLocalPersistence,
    browserLocalPersistence
} from "firebase/auth";
import { getFirestore } from 'firebase/firestore'
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey:           `${process.env.VUE_APP_FIREBASE_API_KEY}`,
  authDomain:        `${process.env.VUE_APP_FIREBASE_AUTH_DOMAIN}`,
  projectId:         `${process.env.VUE_APP_FIREBASE_PROJECT_ID}`,
  storageBucket:     `${process.env.VUE_APP_FIREBASE_STORAGE_BUCKET}`,
  messagingSenderId:`${process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID}`,
  appId:            `${process.env.VUE_APP_FIREBASE_APP_ID}`,
  measurementId:  `${process.env.VUE_APP_FIREBASE_MEASUREMENT_ID}`,

}

console.log(`${process.env.VUE_APP_FIREBASE_API_KEY}`)



// ✅ Initialize Firebase App
const firebaseApp = initializeApp(firebaseConfig)

// ✅ Export Firebase services
const auth = getAuth(firebaseApp)

// 🔑 ตั้ง persistence เพื่อแก้ mobile sessionStorage issue
setPersistence(auth, indexedDBLocalPersistence)
    .catch(err => {
        console.log('⚠️ IndexedDB failed, trying localStorage:', err.message)
        return setPersistence(auth, browserLocalPersistence)
    })
    .catch(err => {
        console.error('⚠️ Persistence setup failed:', err.message)
    })
    .then(() => {
        console.log('✅ Firebase persistence configured')
    })

const db = getFirestore(firebaseApp)

const googleProvider = new GoogleAuthProvider()

const facebookProvider = new FacebookAuthProvider();
facebookProvider.addScope('public_profile');
facebookProvider.addScope('email');
facebookProvider.addScope('pages_show_list');       // ดึงเพจที่ user ดูแล
facebookProvider.addScope('pages_manage_posts');    // สร้าง/แก้ไขโพสต์
facebookProvider.addScope('pages_read_engagement'); // อ่านโพสต์/คอมเมนต์
facebookProvider.addScope('pages_manage_engagement'); // ตอบคอมเมนต์
facebookProvider.addScope('pages_messaging');       // อ่าน/ส่งข้อความ
facebookProvider.addScope('ads_management');        // สร้าง/แก้ไข Ads
facebookProvider.addScope('ads_read');              // อ่าน Ads / Performance
facebookProvider.addScope('business_management');   // จัดการ Business Account
facebookProvider.addScope('pages_manage_metadata');
// ⚠️ ตัดออก — เดิมมี instagram_basic / instagram_manage_messages / instagram_manage_comments
// สำหรับแนวทาง "Instagram API with Facebook Login" แต่เจอ error #3 (Application does not have
// the capability to make this API call) แก้ไม่ได้ ตัดสินใจเลิกใช้แนวทางนี้ทั้งหมด — เปลี่ยนไปใช้
// "Business Login for Instagram" แทน (คนละ flow, คนละ Meta App — ดู
// src/views/InstagramCallbackScreen.vue + backend/routes/api/instagramBusinessLogin.js) ซึ่งไม่ใช้
// Firebase Auth/FacebookAuthProvider เลย ไม่ต้องขอ scope พวกนี้ผ่าน Facebook Login อีกต่อไป

const storage = getStorage(firebaseApp);

export { auth, db, storage, googleProvider, facebookProvider }